var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.749,
    height: 15.095,
    viewBox: "0 0 14.749 15.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Analytics_",
    "data-name": "Analytics ",
    transform: "translate(-153.539 -148.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M175.756,157.843a.3.3,0,0,0,.165-.05l12.068-7.936-.384,1.712a.3.3,0,1,0,.589.132l.546-2.437a.3.3,0,0,0-.222-.368l-2.362-.567a.3.3,0,1,0-.141.587l1.69.406-12.116,7.967a.3.3,0,0,0,.166.554Z",
    transform: "translate(-21.189 0)",
    fill: "#727376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M167.986,301.22H167.6v-9.444a.3.3,0,0,0-.3-.3h-1.953a.3.3,0,0,0-.3.3v9.444h-.924v-7.469a.3.3,0,0,0-.3-.3h-1.953a.3.3,0,0,0-.3.3v7.469h-.722V295.7a.3.3,0,0,0-.3-.3h-1.953a.3.3,0,0,0-.3.3v5.516h-.719v-3.9a.3.3,0,0,0-.3-.3h-1.953a.3.3,0,0,0-.3.3v3.9h-1.164a.3.3,0,0,0,0,.6h14.145a.3.3,0,0,0,0-.6Z",
    transform: "translate(0 -138.408)",
    fill: "#727376"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.59c32293d2718bd637a73910c1deb02e.svg";
export { ForwardRef as ReactComponent };